export default __webpack_public_path__ + "static/media/portatambor.1961988b.png";